var _style, _rect, _g, _path, _path2, _path3, _path4, _path5, _g2, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBauerEngineeringIndia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 182.1 62.36",
    style: {
      enableBackground: "new 0 0 182.1 62.36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#004477;}\n\t.st1{fill:#F3C200;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    className: "st0",
    width: 62.36,
    height: 62.36
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24.16,2.07v21.79c-0.08-0.02-0.44-0.26-1.46-0.26c-0.95,0-2.31,0.95-3.8,0.95c-1.58,0-2.87-1.04-4.28-1.04 c-0.8,0-1.77,0.4-2.13,0.56v1.96c0.36-0.14,1.33-0.51,2.13-0.51c1.34,0,2.63,1,4.28,1c1.29,0,2.76-0.85,3.8-0.85 c0.9,0,1.36,0.32,1.46,0.39v1.43c-0.08-0.02-0.44-0.26-1.46-0.26c-0.95,0-2.31,0.95-3.8,0.95c-1.58,0-2.87-1.04-4.28-1.04 c-0.8,0-1.77,0.4-2.13,0.56v1.96c0.36-0.14,1.33-0.5,2.13-0.5c1.34,0,2.63,1,4.28,1c1.29,0,2.76-0.85,3.8-0.85 c0.9,0,1.36,0.32,1.46,0.39v4.59h-5.77v0.01l12.02,7.29l0-39.51H24.16z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4.47,44.27h6.45c2.16,0,3.6,0.78,3.6,3.1c0,1.8-1.03,2.94-2.78,3.31v0.04c1.94,0.3,2.92,1.05,2.92,3.05 c0,2.57-1.68,3.72-4.17,3.72H4.47V44.27z M7.92,54.57h1.87c0.84,0,1.37-0.45,1.41-1.14c0-0.84-0.52-1.28-1.32-1.28H7.92V54.57z  M7.94,49.65h1.55c0.8,0,1.57-0.34,1.57-1.19c0-0.89-0.45-1.27-1.27-1.27H7.94V49.65z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.27,44.27h5.35l3.55,13.22h-3.62l-0.75-2.85h-3.92l-0.71,2.85h-3.51L18.27,44.27z M20.92,46.65h-0.04 l-1.25,4.96h2.35L20.92,46.65z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.5,52.82c0,3-1.73,4.88-5.25,4.88c-3.52,0-5.25-1.87-5.25-4.88v-8.55h3.39v8.29c0,1.4,0.86,2.03,1.85,2.03 c1,0,1.86-0.64,1.86-2.03v-8.29h3.39V52.82z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.43,44.27h8.82v3.24h-5.58v1.78h5.58v3.13h-5.58v1.93h5.58v3.13h-8.82V44.27z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.12,44.27h5.83c2.21,0,4.44,0.36,4.44,3.53c0,2.57-1.69,3.92-3.49,3.92l3.85,5.77h-4.13l-2.99-5.24h-0.04 v5.24h-3.46V44.27z M51.58,50h2.03c0.82,0,1.32-0.59,1.32-1.34c0-1.09-0.66-1.27-1.59-1.27h-1.76V50z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.2,2.07v21.79c0.09-0.02,0.44-0.26,1.46-0.26c0.95,0,2.3,0.95,3.8,0.95c1.58,0,2.87-1.04,4.28-1.04 c0.8,0,1.77,0.4,2.13,0.56v1.96c-0.36-0.14-1.33-0.51-2.13-0.51c-1.34,0-2.63,1-4.28,1c-1.29,0-2.76-0.85-3.8-0.85 c-0.9,0-1.36,0.32-1.46,0.39v1.43c0.09-0.02,0.44-0.26,1.46-0.26c0.95,0,2.3,0.95,3.8,0.95c1.58,0,2.87-1.04,4.28-1.04 c0.8,0,1.77,0.4,2.13,0.56v1.96c-0.36-0.14-1.33-0.5-2.13-0.5c-1.34,0-2.63,1-4.28,1c-1.29,0-2.76-0.85-3.8-0.85 c-0.9,0-1.36,0.32-1.46,0.39v4.59h5.77v0.01l-12.02,7.29l0-39.51H38.2z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M68.12,25.02h8.84v3.25h-5.59v1.79h5.59v3.14h-5.59v1.93h5.59v3.14h-8.84V25.02z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M78.53,25.02h4.91l3.48,8.48h0.04v-8.48h3.14v13.25h-4.21l-4.18-9.05h-0.04v9.05h-3.14V25.02z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M101.83,35.61c-1.11,2.27-2.91,2.98-4.93,2.98c-3.82,0-5.66-3.3-5.66-6.98c0-4.66,2.87-6.91,5.73-6.91 c1.71,0,3.25,0.39,4.39,1.71v3.7c-0.89-1.29-2.05-2.05-3.64-2.05c-2.36,0-3.12,1.89-3.12,3.89c0,1.86,0.62,3.71,2.55,3.71 c0.55,0,1-0.14,1.32-0.46v-3.68h3.36V35.61z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M103.09,25.02h3.57v13.25h-3.57V25.02z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M108.37,25.02h4.91l3.48,8.48h0.04v-8.48h3.14v13.25h-4.21l-4.18-9.05h-0.04v9.05h-3.14V25.02z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M121.51,25.02h8.84v3.25h-5.59v1.79h5.59v3.14h-5.59v1.93h5.59v3.14h-8.84V25.02z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M131.79,25.02h8.84v3.25h-5.59v1.79h5.59v3.14h-5.59v1.93h5.59v3.14h-8.84V25.02z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M142.13,25.02h5.84c2.21,0,4.45,0.36,4.45,3.53c0,2.57-1.7,3.93-3.5,3.93l3.86,5.78h-4.14l-3-5.25h-0.04v5.25 h-3.46V25.02z M145.59,30.77h2.04c0.82,0,1.32-0.59,1.32-1.34c0-1.09-0.66-1.27-1.59-1.27h-1.77V30.77z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M153.5,25.02h3.57v13.25h-3.57V25.02z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M158.78,25.02h4.91l3.48,8.48h0.04v-8.48h3.14v13.25h-4.21l-4.18-9.05h-0.04v9.05h-3.14V25.02z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M182.08,35.61c-1.11,2.27-2.91,2.98-4.93,2.98c-3.82,0-5.66-3.3-5.66-6.98c0-4.66,2.87-6.91,5.73-6.91 c1.71,0,3.25,0.39,4.39,1.71v3.7c-0.89-1.29-2.05-2.05-3.64-2.05c-2.36,0-3.12,1.89-3.12,3.89c0,1.86,0.62,3.71,2.55,3.71 c0.55,0,1-0.14,1.32-0.46v-3.68h3.36V35.61z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M68.12,44.22h3.57v13.25h-3.57V44.22z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.41,44.22h4.91l3.48,8.48h0.04v-8.48h3.14v13.25h-4.21l-4.18-9.05h-0.04v9.05h-3.14V44.22z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M86.6,44.22h6.07c3.07,0,5.12,1.29,5.12,6c0,4.28-1.98,7.25-6.25,7.25H86.6V44.22z M90.06,54.33h1.93 c2.11,0,2.45-2.52,2.45-3.66c0-1.34-0.2-3.2-2.29-3.2h-2.09V54.33z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M98.95,44.22h3.57v13.25h-3.57V44.22z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.88,44.22h5.36l3.55,13.25h-3.62l-0.75-2.86h-3.93l-0.71,2.86h-3.52L106.88,44.22z M109.54,46.62h-0.04 l-1.25,4.96h2.36L109.54,46.62z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBauerEngineeringIndia);
export default __webpack_public_path__ + "static/media/bauer-engineering-india.4d3be1a87f984e6b4902e13e0a365b6c.svg";
export { ForwardRef as ReactComponent };